import { useEffect, useState } from "react";
import { Button, Col, Drawer, Input, Layout, Row, Typography } from "antd";
import { Link, useHistory } from "react-router-dom";
import {
  Cross,
  CrossIcon,
  CupIcon,
  Facebook,
  Hamburger,
  Insta,
  MainLogo,
  MainLogoHeader,
  SearchIcon,
  Twitter,
  UserIcon,
  Wifi,
  Youtube,
} from "../../assets/images";
import { Content } from "antd/lib/layout/layout";
import { ScrollRotate } from "react-scroll-rotate";
import Localize, { isCart } from "../../utils/string";
import { useDispatch, useSelector } from "react-redux";
import { SearchData } from "../../store/products/productsAsyncActions";
import {
  storeredirectPath,
  storeReleasesEnumsValue,
} from "../../store/products/productsActions";
import { setLoading } from "../../store/common/commonActions";
import Title from "antd/lib/typography/Title";

const { Header } = Layout;

interface Props {
  pathName: string;
}
const AppHeader = ({ pathName }: Props) => {
  const AddedCartProduct: any = useSelector(
    (state: any) => state.products.AddedCartProduct
  );
  const [isVisible, isSetVisible] = useState(false);
  const [isVisibleHeading, setVisibleHeading] = useState(true);
  const [customClass, setCustomClass] = useState("");
  const [searchData, setSearchData] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const date = new Date();
  const footerContent = `©${date.getFullYear()} Prime Direct Distribution Ltd.`;
  const footerContent2 = `Website By`;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust the threshold according to your needs
      if (window.innerWidth > 768) {
        // disable drawer for desktop
        isSetVisible(false);
      }
    };

    // Listen to window resize events
    window.addEventListener("resize", handleResize);

    // Call the handler once to set the initial value
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const pathLocation = history?.location?.pathname;
  useEffect(() => {
    isSetVisible(false);
  }, [pathLocation]);

  useEffect(() => {
    setCustomClass("sub-header");
  }, []);

  const isLogin = useSelector((state: any) => state.user.isLogin);

  const handleSave = async () => {
    setCustomClass("sub-header full-width-header-search");
    if (searchData != "") {
      const value = searchData.replace("&", "%26");
      if (value.trim()) {
        // dispatch(setLoading(true))
        // const response: any = await dispatch(SearchData(query));
        // setSearchData("");
        isSetVisible(false);
        setVisibleHeading(true);
        history.push(`/search?searchItem=${value.trim()}`);
        setCustomClass("sub-header");
        setSearchData("");
      }
    }else{
      if(window.innerWidth < 768){
        setVisibleHeading(false);
      }
    }
  };

  const CrossIcons = () => {
    setVisibleHeading(true);
    setCustomClass("sub-header");
    setSearchData("");
  };
  const onChangeSearch = (value: any) => {
    setSearchData(value);
  };
  const handleSave1 = async (e?: any) => {
    if (e.key === "Enter") {
      const value = searchData.replace("&", "%26");
      if (value.trim()) {
        // dispatch(setLoading(true))
        isSetVisible(false);
        history.push(`/search?searchItem=${value.trim()}`);
        setCustomClass("sub-header");
        setSearchData("");
      }
    }
  };
  const handleRedirect = () => {
    dispatch(storeredirectPath(false));
    dispatch(storeReleasesEnumsValue(1));
  };
  return (
    <Header className={`${customClass} my-header`}>
      <div className="top-header-wrapper new-header">
        {/* <Col className="left-header desktop" xs={5} sm={3} xl={7}>
          <Link onClick={() => isSetVisible(false)} to="/">
            {" "}
            <ScrollRotate>
              <MainLogoHeader />
            </ScrollRotate>
            <MainLogoHeader />
          </Link>
        </Col> */}
        <div className="left-header">
          <Link onClick={() => isSetVisible(false)} className={`main-logo ${!isVisibleHeading ?  'new-main-logo' : ''}`} to="/">
            {" "}
            <ScrollRotate>
              <MainLogoHeader />
            </ScrollRotate>
            {
              isVisibleHeading && (
            <Title level={2}>
              {Localize.MainHeaderTitle}
              {/* <Typography.Text>®</Typography.Text> */}
              {Localize.MainHeaderTitle1}
            </Title>
              )
            }
          </Link>
        </div>
        <div className="center-header">
          <Link
            className={`rounded-btn ${pathName === "/releases" && " active"}`}
            to="/releases"
            onClick={handleRedirect}
          >
            {Localize.ReleaseLinkText}
          </Link>
          <Link
            className={`rounded-btn ${pathName === "/labels" && " active"}`}
            to="/labels"
          >
            {Localize.LabelLinkText}
          </Link>
          <Link
            className={`rounded-btn ${pathName === "/services" && " active"}`}
            to="/services"
          >
            {Localize.ServiceLinkText}
          </Link>
          <Link
            className={`rounded-btn ${pathName === "/contact" && " active"}`}
            to="/contact"
          >
            {Localize.TeamLinkText}
          </Link>
        </div>
        <div className="right-header">
          <Content className="right-inner-icons">
            <div className="search-box">
              <Input
                placeholder="Search by title, cat number, artist, label"
                value={searchData}
                onChange={(e) => onChangeSearch(e.target.value)}
                onKeyDown={handleSave1}
              />
              <Button className="searchicon-btn" onClick={handleSave}>
                <SearchIcon />
              </Button>
              <Button className="crossicon-btn" onClick={CrossIcons}>
                <Cross />
              </Button>
            </div>
            <Link onClick={() => isSetVisible(false)} to={isLogin ? "/profile" : "/login"} className="profile-icon login-btn-header" >
              {isLogin ? (<UserIcon />) : (<span>{Localize.LoginTitle}</span>)}
            </Link>
            {
              isCart && isLogin && (
            <Link to="/cart" className="cart-icon">
              <CupIcon />
              {AddedCartProduct?.cartItems?.length > 0 ? (
                <span className="cart-count">
                  {AddedCartProduct?.cartItems?.length}
                </span>
              ) : (
                ""
              )}{" "}
            </Link>
              )
            }
          </Content>
          <div className="mobile-header">
            {isVisible ? (
              <div onClick={() => isSetVisible(false)}>
                <CrossIcon />
              </div>
            ) : (
              <div onClick={() => isSetVisible(true)}>
                <Hamburger />
              </div>
            )}
            <Drawer
              className="mobile-header-drawer"
              closable={false}
              visible={isVisible}
            >
              <div className="mobile-xs">
                {/* <Typography.Text>
                Worldwide physical and digital distribution. From music lovers,
                to music lovers.
              </Typography.Text>
              <Typography.Text className="center-text">
                Our previous website design can still be viewed{" "}
                <a href="https://media.primedirectdist.co.uk/" target="_blank">
                  here
                </a>
              </Typography.Text> */}
                <div>
                  <Link
                    className={`rounded-btn ${pathName === "/releases" && " active"
                      }`}
                    to="/releases"
                    onClick={() => isSetVisible(false)}
                  >
                    Releases
                  </Link>
                  <Link
                    className={`rounded-btn ${pathName === "/labels" && " active"
                      }`}
                    to="/labels"
                    onClick={() => isSetVisible(false)}
                  >
                    Labels
                  </Link>
                  <Link
                    className={`rounded-btn ${pathName === "/services" && " active"
                      }`}
                    to="/services"
                    onClick={() => isSetVisible(false)}
                  >
                    Services
                  </Link>
                  <Link
                    className={`rounded-btn ${pathName === "/contact" && " active"
                      }`}
                    to="/contact"
                    onClick={() => isSetVisible(false)}
                  >
                    Contact
                  </Link>
                </div>
                <div className="icons">
                  <a href="https://www.instagram.com/primedirectdistribution" rel="noreferrer" target="_blank">
                    <Insta />
                  </a>
                  <a className="twitterIcon" href="https://twitter.com/primedirectdist" rel="noreferrer" target="_blank">
                    <Twitter />
                  </a>
                  <a href="https://www.facebook.com/PrimeDirectDistribution" rel="noreferrer" target="_blank">
                    <Facebook />
                  </a>
                  <a href=" https://open.spotify.com/user/primedirectdist?si=f127181e48bc48a9" rel="noreferrer" target="_blank">
                    <Wifi />
                  </a>
                </div>
                <Typography.Text className="bottom-text">
                  <Link to="/terms">{Localize.TermsConditionsText}</Link>  {" "}
                  <Link to="/policy">{Localize.PrivacyPolicy}</Link>
                  {footerContent}
                  <div>
                    <span className="bottom-website-text" style={{ marginTop: "0", gap: '8px' }}>{footerContent2 + " "}<a href="https://anotherkind.co.uk/" target="_blank"> Another Kind</a></span>

                  </div>
                </Typography.Text>
              </div>
            </Drawer>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;
